import type { FC } from 'react';

import balanceAndBonusesTopupButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/balance_and_bonuses/balance_and_bonuses_topup_button_click';

import useOnOffState from 'hooks/common/useOnOffState';

import CardTemplate from 'components/BalanceAndBonuses/CardTemplate/CardTemplate';
import { BalanceCardBottom } from 'components/common/BalanceCardContent/BalanceCardBottom/BalanceCardBottom';
import { BalanceCardTop } from 'components/common/BalanceCardContent/BalanceCardTop/BalanceCardTop';
import BalanceReplenishmentModal from 'components/common/BalanceReplenishmentModal/BalanceReplenishmentModal';

import { useSelector } from 'store/utils';

export const BalanceCard: FC<{ loading?: boolean }> = ({ loading }) => {
    const { realBalance, reservedBalance, availableBalance } = useSelector(({ balance }) => balance);

    const [
        isBalanceReplenishmentModalVisible,
        setIsBalanceReplenishmentModalVisibleOn,
        setIsBalanceReplenishmentModalVisibleOff,
    ] = useOnOffState(false);

    const onTopUpButtonClick = () => {
        setIsBalanceReplenishmentModalVisibleOn();
        balanceAndBonusesTopupButtonClick({ balance: realBalance, reservedBalance, availableBalance });
    };

    return (
        <>
            <CardTemplate
                loading={loading}
                mobileHeight={201}
                topContent={<BalanceCardTop onTopUpButtonClick={onTopUpButtonClick} />}
                bottomContent={<BalanceCardBottom />}
            />
            <BalanceReplenishmentModal
                withDescription={false}
                isVisible={isBalanceReplenishmentModalVisible}
                closeModal={setIsBalanceReplenishmentModalVisibleOff}
            />
        </>
    );
};
